<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { t } from '@/lib/i18n'
import { useInitStore } from '@/stores/initStore'

const initStore = useInitStore()

function close() {
  initStore.forgotCoralIdPopup = false
}

function onKeydown(event: KeyboardEvent) {
  if (event.key === 'Escape') close()
}

onMounted(() => document.addEventListener('keydown', onKeydown))
onUnmounted(() => document.removeEventListener('keydown', onKeydown))
</script>

<template lang="pug">
.popupForgotCoralId
  .overlay(@click="close")
  .login-header-popup(class="absolute text-center p-8 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2")
    .absolute.top-3.right-3.cursor-pointer(@click="close")
      svg(width="24", height="24", viewBox="0 0 24 24", fill="none", xmlns="http://www.w3.org/2000/svg")
        path(d="M6 18L18 6M6 6L18 18L6 6Z", stroke="#858C91", stroke-width="2", stroke-linecap="round", stroke-linejoin="round")
    .title(class="mb-2 md:mb-4")
      span(v-html="t('Registration_ForgotYourCoralId')")
    .text-base.text-gray-500(class="mb-6 md:mb-11")
      span(v-html="t('Registration_IfYouHavePreviouslyPlacedOrder')")
    a(href="/support/list.php", class="btn btn-primary rounded hover:opacity-90 transition duration-400", v-html="t('Registration_Support')")
</template>

<style lang="scss" scoped>
.overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 99;
  padding: 0 18px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #00000034;
  transition: all 0.3s ease-in-out;
}
.login-header-popup {
  background-color: #ffffff;
  box-shadow: -4px 0px 20px #413d581a;
  border-radius: 16px;
  max-width: 620px;
  min-width: 300px;
  opacity: 1;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  transition: all 0.3s ease-in-out;

  .title {
    font-weight: 500;
  }

  .btn {
    max-width: 232px;
    margin: 0 auto;
  }
}
</style>
